module.exports = __webpack_public_path__ + "static/media/rusty_sword.9c1e4a30.png";